module.exports = __webpack_public_path__ + "05_hair_black.c8af7d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/05_hair_black.png
// module id = QKiu
// module chunks = 0